<div
  *ngIf="haveEntities"
  class="entity-path-display">
  <ng-container
    *ngTemplateOutlet="
      entityTemplate;
      context: { entities: stackEntities, title: 'Stack' }
    "></ng-container>
  <ng-container
    *ngTemplateOutlet="
      entityTemplate;
      context: { entities: companiesEntities, title: 'Companies' }
    "></ng-container>
  <ng-container
    *ngTemplateOutlet="
      entityTemplate;
      context: { entities: groupsEntities, title: 'Groups' }
    "></ng-container>
  <ng-container
    *ngTemplateOutlet="
      entityTemplate;
      context: { entities: vehiclesEntities, title: 'Vehicles' }
    "></ng-container>
  <ng-container
    *ngTemplateOutlet="
      entityTemplate;
      context: { entities: devicesEntities, title: 'Devices' }
    "></ng-container>
</div>

<ng-template
  #entityTemplate
  let-entities="entities"
  let-title="title">
  <div
    *ngIf="entities?.length"
    class="entity-path-display__entities_title">
    {{ title }}
  </div>
  <span
    *ngFor="let entity of entities"
    class="entity-path-display__container">
    <span class="entity-path-display__entity-name">
      {{ entity | entityPath }}
    </span>
    <i
      *ngIf="!predefinedEntity"
      class="lx-icon lx-trash entity-path-display__x"
      (click)="removeEntity(entity)"></i>
  </span>
</ng-template>
